// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

::ng-deep #holder > li {
  padding: 5px;
  margin: 2px;
  display: inline-block;
  border-color: #ddd;
}

::ng-deep #holder > li[data-page] {
  border: solid #a0a0a0 1px;
  border-radius: 5px;
}

::ng-deep #holder > li.separator:before {
  content: "...";
}

::ng-deep #holder > li.active {
  background-color: #f4f4f4;
  color: inherit;
}

::ng-deep #holder > li[data-page]:hover {
  cursor: pointer;
}

::ng-deep .no-profile {
  background-image: url("https://assets.foursightonline.com/app/images/foursight-profile-types.svg") !important;
}

ul.dropdown-menu li a span {
  display: block;
  font-size: 65%;
  text-align: center;
  margin: -10px;
}

.checkbox input[type=checkbox] {
  margin-left: 0px;
}

.split-groups {
  margin-left: 10px;
}

.selectDataChild th {
  min-width: 100px;
}

.selectDataChild th, .selectDataChild td {
  padding: 5px 10px;
}

table.selectDataChild {
  width: 100%;
}

table.selectDataChild tr:nth-child(odd) {
  background: #f1f1f2;
}

.top-right-button .btn {
  margin: 0 5px;
}

::ng-deep.download {
  width: auto;
  margin-left: 20px;
}

::ng-deep.download-options {
  display: inline-block;
}

::ng-deep.custom-radio-section {
  margin-top: 10px;
}
::ng-deep.custom-radio-section .btn-primary {
  display: block;
}

.ibox-content {
  border-top: 0px;
}

.group-title-area .dropdown-menu {
  position: absolute;
  right: 0;
  left: auto;
  top: 100%;
  width: 110px;
  min-width: inherit;
}

@media screen and (max-width: 380px) {
  .group-title-area .btn-group.pull-right {
    float: none !important;
    margin-left: 10px;
    margin-top: 10px;
    clear: both;
    display: block;
  }
}
.dropdown-submenu {
  position: relative;
}

.group-dropdown.dropdown {
  position: relative;
  float: left;
}
.group-dropdown.dropdown button.btn {
  font-size: 13px;
}
.group-dropdown.dropdown .dropdown-menu.inner-toggle {
  position: absolute;
  left: 0;
  right: auto;
  width: 210px;
  padding: 10px 10px;
}
.group-dropdown.dropdown .dropdown-menu.inner-toggle .download-options {
  float: left;
  width: 50%;
}
.group-dropdown.dropdown .dropdown-menu.inner-toggle .download-options select.form-control {
  margin: 0;
}
.group-dropdown.dropdown .dropdown-menu.inner-toggle .custom-radio-section {
  float: left;
  width: 50%;
  margin: 0px;
  padding-left: 20px;
}

::ng-deep .dropdown-submenu .dropdown-menu {
  top: 0;
  left: 100%;
  margin-top: -1px;
}

::ng-deep.swal2-modal {
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  justify-content: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
}

::ng-deep .swal2-show {
  background-color: white;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  width: 478px;
  padding: 17px;
  border-radius: 5px;
  text-align: center;
  position: fixed;
  left: 0 !important;
  top: 0 !important;
  transform: translate(0, 0) !important;
  -webkit-transform: translate(0, 0) !important;
  -moz-transform: translate(0, 0) !important;
  margin-left: -256px;
  overflow: hidden;
  z-index: 99999;
  margin-top: -168px;
}
::ng-deep .swal2-show:focus {
  outline: none;
}
::ng-deep .swal2-show button.swal2-cancel.swal2-styled {
  background-color: #D0D0D0 !important;
  color: white;
  border: none;
  box-shadow: none;
  font-size: 17px;
  font-weight: 500;
  border-radius: 5px;
  padding: 10px 32px;
  margin: 26px 5px 0 5px;
  cursor: pointer;
}
::ng-deep .swal2-show button.swal2-cancel.swal2-styled:focus {
  outline: none;
}
::ng-deep .swal2-show button.swal2-confirm.swal2-styled {
  background-color: #AEDEF4;
  color: white;
  border: none;
  box-shadow: none;
  font-size: 17px;
  font-weight: 500;
  border-radius: 5px;
  padding: 10px 32px;
  margin: 26px 5px 0 5px;
  cursor: pointer;
}
::ng-deep .swal2-show button.swal2-confirm.swal2-styled:focus {
  outline: none;
}
::ng-deep .swal2-show .swal2-icon.swal2-warning {
  width: 80px;
  height: 80px;
  border: 4px solid gray;
  border-radius: 40px;
  border-radius: 50%;
  margin: 20px auto;
  padding: 0;
  position: relative;
  box-sizing: content-box;
  border-color: #F8BB86;
  font-size: 58px;
  color: #F8BB86;
  justify-content: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
}
::ng-deep .swal2-show .swal2-icon.swal2-warning:focus {
  outline: none;
}
::ng-deep .swal2-show h2#swal2-title {
  color: #575757;
  font-size: 30px;
  text-align: center;
  font-weight: 600;
  text-transform: none;
  position: relative;
  margin: 25px 0;
  padding: 0;
  line-height: 40px;
  display: block;
}
::ng-deep .swal2-show h2#swal2-title:focus {
  outline: none;
}
::ng-deep .swal2-show div#swal2-content {
  color: #797979;
  font-size: 16px;
  text-align: center;
  font-weight: 300;
  position: relative;
  text-align: inherit;
  float: none;
  margin: 0;
  padding: 0;
  line-height: normal;
}
::ng-deep .swal2-show div#swal2-content:focus {
  outline: none;
}

::ng-deep .swal2-shown {
  background-color: black;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=40)";
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99999;
}

.ibox-content.group-list .inner-box.col-lg-3:nth-child(4n+1) {
  clear: both;
}

.ibox-content.group-list .inner-box.col-lg-2:nth-child(6n+1) {
  clear: both;
}

.connectPanels .profile-image {
  width: 100%;
  max-width: 40px;
}
.connectPanels .cursor-pointer {
  cursor: pointer;
  float: left;
  clear: both;
  margin-top: 10px;
}

.hide-wrapper .ibox-content h3 > span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 117px;
  display: inline-block;
}
.hide-wrapper .superCompactView h3 > span {
  width: 65px;
}
.hide-wrapper .hide-content {
  display: none;
}
.hide-wrapper .CompactView h3 > span {
  width: 115px;
}

.global-check {
  padding-top: 10px;
}
.global-check input[type=checkbox] {
  width: 15px !important;
  vertical-align: middle;
  display: inline-block;
  height: 15px;
  margin-right: 5px;
}

.compact-box-section {
  padding-top: 20px;
}

.group-list .row > .col-md-4:nth-child(4n+1) {
  clear: both;
}

.hide-wrapper .group-list .row > .col-md-4:nth-child(4n+1) {
  clear: none;
}

.sortable-list.agile-list li.success-element {
  position: relative;
  padding-top: 18px;
}
.sortable-list.agile-list li.success-element .quick-card-editor-buttons {
  position: absolute;
  right: 0;
  top: 0;
}
.sortable-list.agile-list li.success-element .quick-card-editor-buttons a.btn.subgroup-edit {
  background: transparent;
  border: none;
  font-size: 0;
  position: relative;
}
.sortable-list.agile-list li.success-element .quick-card-editor-buttons a.btn.subgroup-edit:before {
  content: "...";
  font-size: 25px;
  color: #b7b7b7;
  line-height: 3px;
}
.sortable-list.agile-list li.success-element .quick-card-editor-buttons a.quick-card-editor-buttons-item {
  display: none;
}
.sortable-list.agile-list li.success-element .quick-card-editor-buttons.subgroup-open a.quick-card-editor-buttons-item {
  display: block !important;
  position: absolute;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 5px;
  z-index: 99;
}
.sortable-list.agile-list li.success-element .quick-card-editor-buttons.subgroup-open a.quick-card-editor-buttons-item span.quick-card-editor-buttons-item-text {
  color: #fff;
  padding: 10px 20px;
  display: block;
}
.sortable-list.agile-list li.success-element .quick-card-editor-buttons.subgroup-open a.quick-card-editor-buttons-item .subgroup-move {
  background: #fff;
  position: absolute;
  left: 0;
  padding: 20px 20px 15px 20px;
  border-radius: 4px;
  top: 100%;
  min-width: 230px;
  display: none;
  box-shadow: 1px 10px 29px rgba(0, 0, 0, 0.1);
}
.sortable-list.agile-list li.success-element .quick-card-editor-buttons.subgroup-open a.quick-card-editor-buttons-item .subgroup-move a.close {
  position: absolute;
  right: 3px;
  top: 6px;
  width: 15px;
  font-size: 0;
  opacity: 0.4;
  z-index: 9999;
  height: 13px;
}
.sortable-list.agile-list li.success-element .quick-card-editor-buttons.subgroup-open a.quick-card-editor-buttons-item .subgroup-move a.close:before {
  content: "";
  background: #000;
  position: absolute;
  left: 6px;
  top: 0;
  width: 2px;
  height: 13px;
  transform: rotate(45deg);
}
.sortable-list.agile-list li.success-element .quick-card-editor-buttons.subgroup-open a.quick-card-editor-buttons-item .subgroup-move a.close:after {
  content: "";
  background: #000;
  position: absolute;
  left: 6px;
  top: 0;
  width: 2px;
  height: 13px;
  transform: rotate(-45deg);
}
.sortable-list.agile-list li.success-element .quick-card-editor-buttons.subgroup-open a.quick-card-editor-buttons-item .subgroup-move .list {
  padding: 10px 10px;
  background: #e0e0e0;
  border-radius: 4px;
  color: #333;
}
.sortable-list.agile-list li.success-element .quick-card-editor-buttons.subgroup-open a.quick-card-editor-buttons-item .subgroup-move .list h2 {
  font-weight: bold;
  font-size: 17px;
  margin: 0px 0 5px 0;
}
.sortable-list.agile-list li.success-element .quick-card-editor-buttons.subgroup-open a.quick-card-editor-buttons-item .subgroup-move .list select {
  width: 100%;
}
.sortable-list.agile-list li.success-element .quick-card-editor-buttons.subgroup-open a.quick-card-editor-buttons-item.sub-subgroup-edit .subgroup-move {
  display: block !important;
}

.col-lg-1 h3 {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 64px !important;
  overflow: hidden;
  display: block;
  padding: 2px;
}
.col-lg-1 .ibox-content.group-content-area {
  padding: 0;
}

h5.team-title {
  padding-left: 10px;
}

#group-algorithm {
  width: auto;
  padding: 0px;
}

.compact-radio {
  margin: 5px;
}

.custom-pop-input input[type=number] {
  width: auto;
}

.group-inner-btn {
  width: 37%;
}

.reset-input th {
  position: relative;
}
.reset-input th input[type=search] {
  width: 100% !important;
}
.reset-input th .reset-close {
  display: none;
  position: absolute;
  top: 0;
  right: 25px;
  bottom: 0;
  margin: auto;
  border-radius: 50%;
  background: #ddd;
  border: none !important;
  text-align: center;
  font-size: 14px;
  padding: 0px !important;
  height: 16px !important;
  width: 16px !important;
  color: #fff;
  line-height: 1.2 !important;
  font-family: Arial !important;
  transform: rotate(45deg) !important;
  -webkit-transform: rotate(45deg) !important;
}
.reset-input th:hover .reset-close {
  display: block;
}

.ibox-table > .row {
  display: flex;
  flex-wrap: nowrap;
}
.ibox-table > .row .inner-box {
  display: inline-block;
  max-width: 270px;
  vertical-align: top;
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
  flex: 0 0 270px;
  -webkit-flex: 0 0 270px;
  -ms-flex: 0 0 270px;
}
.ibox-table > .row .inner-box.superCompactView {
  flex: 0 0 100px;
  -webkit-flex: 0 0 100px;
  -ms-flex: 0 0 100px;
  max-width: 115px;
}
.ibox-table > .row .inner-box.superCompactView .ibox-content {
  padding: 5px;
}
.ibox-table > .row .inner-box.CompactView {
  flex: 0 0 150px;
  -webkit-flex: 0 0 150px;
  -ms-flex: 0 0 150px;
  max-width: 150px;
}
.ibox-table > .row .inner-box.CompactView .ibox-content {
  padding: 5px;
}

.form-popup {
  position: relative;
}
.form-popup button.btn-primary {
  position: absolute;
  bottom: 0;
  right: 0;
}

span.sortby {
  width: 100%;
  height: 100%;
  position: absolute;
  text-align: right;
  left: 0px;
  z-index: 99999;
  padding-right: 14px;
}

/* iCheck plugin Square skin, green
----------------------------------- */
::ng-deep .compact-box-section {
  /* HiDPI support */
}
::ng-deep .compact-box-section .icheckbox_square-green,
::ng-deep .compact-box-section .iradio_square-green {
  display: inline-block;
  *display: inline;
  vertical-align: middle;
  margin: 0;
  padding: 0;
  width: 22px;
  height: 22px;
  background: url("https://assets.foursightonline.com/app/images/green.png") no-repeat;
  border: none;
  cursor: pointer;
  margin-left: 15px;
  float: none !important;
}
::ng-deep .compact-box-section label {
  vertical-align: middle;
  margin-bottom: 0;
  margin-left: 7px;
  font-weight: 700;
}
::ng-deep .compact-box-section .icheckbox_square-green {
  background-position: 0 0;
}
::ng-deep .compact-box-section .icheckbox_square-green.hover {
  background-position: -24px 0;
}
::ng-deep .compact-box-section .icheckbox_square-green.checked {
  background-position: -48px 0;
}
::ng-deep .compact-box-section .icheckbox_square-green.disabled {
  background-position: -72px 0;
  cursor: default;
}
::ng-deep .compact-box-section .icheckbox_square-green.checked.disabled {
  background-position: -96px 0;
}
::ng-deep .compact-box-section .iradio_square-green {
  background-position: -120px 0;
}
::ng-deep .compact-box-section .iradio_square-green.hover {
  background-position: -144px 0;
}
::ng-deep .compact-box-section .iradio_square-green.checked {
  background-position: -168px 0;
}
::ng-deep .compact-box-section .iradio_square-green.disabled {
  background-position: -192px 0;
  cursor: default;
}
::ng-deep .compact-box-section .iradio_square-green.checked.disabled {
  background-position: -216px 0;
}
@media (min-resolution: 120dpi) {
  ::ng-deep .compact-box-section .icheckbox_square-green,
  ::ng-deep .compact-box-section .iradio_square-green {
    background-image: url("https://assets.foursightonline.com/app/images/green@2x.png");
    background-size: 240px 24px;
  }
}

@media screen and (max-width: 900px) {
  .page-heading .col-lg-10 {
    width: auto;
  }
  .ibox-title.top-right-button .right-side-btn {
    float: none !important;
    width: 100%;
    text-align: left;
    padding-top: 15px;
    padding-bottom: 15px;
    display: inline-block;
  }
}
::ng-deep.swal2-shown {
  z-index: 999999;
}

::ng-deep.swal2-modal {
  max-width: 500px !important;
  width: 100% !important;
  left: 0 !important;
  top: 0 !important;
  transform: translate(0, 0) !important;
  -webkit-transform: translate(0, 0) !important;
  -moz-transform: translate(0, 0) !important;
  margin-left: 0 !important;
  margin-top: 0 !important;
  box-sizing: border-box !important;
  bottom: 0;
  right: 0;
  margin: auto !important;
  height: 390px;
}

@media screen and (max-width: 380px) {
  ::ng-deep.swal2-modal {
    height: inherit;
  }
}
::ng-deep.previous-btn {
  background-color: rgb(105, 190, 40) !important;
  color: #fff !important;
}

.top-groups {
  margin-right: 10px;
}

.main-top-session {
  margin-top: 15px;
}

.manage-members-wrapper {
  margin-bottom: 20px;
}
.manage-members-wrapper .manage-inner {
  float: none;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 15px;
}
.manage-members-wrapper .manage-inner h2 {
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 30px;
}
.manage-members-wrapper .manage-inner h3 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.manage-members-wrapper .manage-inner .inner-block {
  display: flex;
  display: -ms-flexbox;
  flex-wrap: wrap;
  -ms-flex-wrap: wrap;
}
.manage-members-wrapper .manage-inner .inner-block .inner-single-box {
  padding: 15px;
  border: 3px solid #aaa;
  height: 100%;
  border-radius: 5px;
}
.manage-members-wrapper .manage-inner .inner-block .inner-single-box i {
  font-size: 60px;
}
.manage-members-wrapper .manage-inner .inner-block .inner-single-box ul {
  margin-top: 40px;
}
.manage-members-wrapper .manage-inner .inner-block .inner-single-box ul li:first-child {
  padding-bottom: 10px;
}
.manage-members-wrapper .manage-inner .inner-block .inner-single-box ul li:nth-child(2) {
  font-size: 14px;
}
.manage-members-wrapper .manage-inner .inner-block .inner-single-box ul li:nth-child(3) {
  margin-top: 10px;
}
.manage-members-wrapper .manage-inner .bottom-member {
  padding-top: 15px;
  padding-bottom: 15px;
}

.add-mbr-block .inner-single-box {
  position: relative;
  padding-bottom: 35px !important;
}
.add-mbr-block h5 {
  position: absolute;
  left: 0;
  bottom: 4px;
  right: 0;
}

.manage-profile-txt tr td {
  text-align: left;
}
.manage-profile-txt tr td:last-child, .manage-profile-txt tr th:last-child {
  text-align: center !important;
}

.border-green {
  border-color: #86b74b !important;
}

::ng-deep.swal2-icon-text {
  font-size: 1.3em;
  line-height: 1;
}

::ng-deep.grey {
  background: rgba(236, 236, 236, 0.9);
}

.inner-box:not(.CompactView, .superCompactView) .group-member-name {
  white-space: nowrap;
  width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.inner-box.CompactView .agile-list li .group-member-name, .inner-box.CompactView .agile-list li span {
  font-size: 10px;
}

span.no-org {
  white-space: nowrap;
  width: 38px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  font-size: 10px;
}

::ng-deep .modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}
::ng-deep .modal.show {
  display: block !important;
}
::ng-deep .modal.grey {
  background: rgba(236, 236, 236, 0.9);
}
::ng-deep .modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
::ng-deep .modal.fade.in {
  opacity: 1;
}
::ng-deep .modal.in .modal-dialog {
  transform: translate(0, 0);
}
::ng-deep .modal.modal-open {
  overflow-x: hidden;
  overflow-y: auto;
}
::ng-deep .modal .modal-dialog {
  position: relative;
  width: auto;
  margin: 10px;
}
@media (min-width: 768px) {
  ::ng-deep .modal .modal-dialog {
    width: 600px;
    margin: 30px auto;
  }
}
::ng-deep .modal .modal-dialog .modal-content {
  background-clip: padding-box;
  background-color: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  outline: 0 none;
  position: relative;
}
::ng-deep .modal .modal-dialog .modal-content .close {
  float: right;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  filter: alpha(opacity=20);
  opacity: 0.2;
}
::ng-deep .modal .modal-dialog .modal-content .close:focus-visible {
  outline: none;
}
::ng-deep .modal .modal-dialog .modal-content button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  appearance: none;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form .form-group {
  margin-bottom: 15px;
}
::ng-deep .modal .f-btn {
  color: #fff;
  font-size: 14px;
  border-color: #73BF38;
  background-color: #73BF38;
}
::ng-deep .modal .f-btn:hover {
  border-color: #4cae4c;
  background-color: #4cae4c;
}
::ng-deep .modal .f-btn--seagrn {
  border-color: #1dc5a3;
  background-color: #1dc5a3;
}
::ng-deep .modal .f-btn--seagrn:hover {
  border-color: #1dc5a3;
  background-color: #1dc5a3;
}
::ng-deep .modal .f-btn--dngr {
  color: #fff;
  border-color: #ED5565;
  background-color: #ED5565;
}
::ng-deep .modal .f-btn--dngr:hover {
  border-color: #ec4758;
  background-color: #ec4758;
}
::ng-deep .modal .f-btn--info {
  color: #fff;
  border-color: #23c6c8;
  background-color: #23c6c8;
}
::ng-deep .modal .f-btn--info:hover {
  border-color: #21b9bb;
  background-color: #21b9bb;
}
::ng-deep .modal .f-btn--wrng {
  color: #fff;
  border-color: #f8ac59;
  background-color: #f8ac59;
}
::ng-deep .modal .f-btn--wrng:hover {
  border-color: #f7a54a;
  background-color: #f7a54a;
}

::ng-deep.modal-open {
  overflow: hidden;
}

.dialogbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(236, 236, 236, 0.9);
  z-index: 99999;
}
.dialogbox__wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 30px;
}
.dialogbox__inner {
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}
.dialogbox__inner[data-width=small] {
  width: min(390px, 100%);
}
.dialogbox__inner[data-width=medium] {
  width: min(500px, 100%);
}
.dialogbox__hdr {
  padding: 15px 30px;
  border-bottom: 1px solid #ddd;
  position: relative;
}
.dialogbox__hdr h2 {
  font-size: 17px;
  line-height: 1.3;
  font-weight: 400;
}
.dialogbox__ftr {
  border-top: 1px solid #ddd;
}
.dialogbox .dialogbox__steps :is(ul, ol):last-child {
  margin-bottom: 0;
}
.dialogbox .dialogbox__steps li {
  font-size: 12px;
}
.dialogbox__smalllabel {
  font-size: 12px;
  font-weight: 400;
}
.dialogbox label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 0;
  font-weight: 700;
  margin-top: 0;
}
.dialogbox label:last-child {
  margin-bottom: 0;
}
.dialogbox select,
.dialogbox input[type=text] {
  height: 35px;
  padding: 3px 10px;
  width: 100%;
  background-color: #fff;
  border: 1px solid #ddd;
}
.dialogbox select:focus,
.dialogbox input[type=text]:focus {
  outline: none;
}
.dialogbox input[type=radio] {
  margin: 0 5px 0 0;
  position: relative;
  top: 2px;
}
.dialogbox__dpsteps {
  counter-reset: section;
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.dialogbox__dpsteps-hdr::before {
  counter-increment: section;
  content: counters(section, ".") ". ";
  font-weight: 700;
}
.dialogbox__close {
  --cSize: 16px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 15px;
  width: var(--cSize);
  height: var(--cSize);
  padding: 0;
  border: 0;
  background-color: transparent;
  opacity: 0.2;
  transition: 0.3s;
  cursor: pointer;
}
.dialogbox__close:hover {
  opacity: 0.4;
}
.dialogbox__close::before, .dialogbox__close::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  width: 2px;
  height: 100%;
  background-color: #000;
  border-radius: 2px;
}
.dialogbox__close::after {
  transform: translate(-50%, -50%) rotate(45deg);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/orgs-individual/training-sessions/training-sessions.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA7YA;EACE,YAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;AAgZF;;AA9YA;EACE,yBAAA;EACA,kBAAA;AAiZF;;AA/YA;EACE,cAAA;AAkZF;;AAhZA;EACE,yBAAA;EACA,cAAA;AAmZF;;AAjZA;EACE,eAAA;AAoZF;;AAlZA;EACE,6GAAA;AAqZF;;AAnZA;EACC,cAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;AAsZD;;AApZA;EACC,gBAAA;AAuZD;;AArZA;EACC,iBAAA;AAwZD;;AArZA;EACE,gBAAA;AAwZF;;AApZA;EACE,iBAAA;AAuZF;;AArZA;EACC,WAAA;AAwZD;;AAtZA;EACI,mBDNkB;AC+ZtB;;AAvZA;EACC,aAAA;AA0ZD;;AAxZA;EACC,WAAA;EACA,iBAAA;AA2ZD;;AAzZA;EACC,qBAAA;AA4ZD;;AAzZA;EACC,gBAAA;AA4ZD;AA3ZC;EACC,cAAA;AA6ZF;;AA1ZA;EACC,eAAA;AA6ZD;;AA3ZA;EACC,kBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;AA8ZD;;AA5ZA;EACC;IACO,sBAAA;IACH,iBAAA;IACA,gBAAA;IACA,WAAA;IACA,cAAA;EA+ZH;AACF;AA7ZA;EACC,kBAAA;AA+ZD;;AA5ZA;EACC,kBAAA;EACA,WAAA;AA+ZD;AA9ZC;EACC,eAAA;AAgaF;AA9ZC;EACC,kBAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAgaF;AA/ZE;EACC,WAAA;EACA,UAAA;AAiaH;AAhaG;EACC,SAAA;AAkaJ;AA/ZE;EACC,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AAiaH;;AA7ZA;EACC,MAAA;EACA,UAAA;EACA,gBAAA;AAgaD;;AA9ZA;EACI,eAAA;EACA,uBAAA;EACA,oBAAA;EACA,uBAAA;EACA,+BAAA;EACA,4BAAA;AAiaJ;;AA/ZA;EACC,uBAAA;EACA,wEAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,6CAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAkaD;AAjaC;EACC,aAAA;AAmaF;AAjaC;EACC,oCAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAmaF;AAlaE;EACC,aAAA;AAoaH;AAjaC;EACC,yBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAmaF;AAlaE;EACC,aAAA;AAoaH;AAjaC;EACC,WAAA;EACA,YAAA;EACA,sBAAA;EAEA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACE,uBAAA;EACC,+BAAA;EACA,4BAAA;AAmaL;AAlaE;EACC,aAAA;AAoaH;AAjaC;EACC,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;AAmaF;AAlaE;EACC,aAAA;AAoaH;AAjaC;EACC,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AAmaF;AAlaE;EACC,aAAA;AAoaH;;AAhaA;EACC,uBAAA;EACA,iEAAA;EACA,oCAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;AAmaD;;AAjaA;EACC,WAAA;AAoaD;;AAlaA;EACC,WAAA;AAqaD;;AAlaC;EACI,WAAA;EACA,eAAA;AAqaL;AAnaC;EACI,eAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AAqaL;;AA1ZK;EACC,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,qBAAA;AA6ZN;AAvZI;EACI,WAAA;AAyZR;AArZC;EACC,aAAA;AAuZF;AAnZG;EACI,YAAA;AAqZP;;AA/YA;EACC,iBAAA;AAkZD;AAjZC;EACC,sBAAA;EACG,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;AAmZL;;AAhZA;EACC,iBAAA;AAmZD;;AAhZA;EACI,WAAA;AAmZJ;;AAhZA;EACI,WAAA;AAmZJ;;AA9YC;EACI,kBAAA;EACA,iBAAA;AAiZL;AAhZE;EACC,kBAAA;EACG,QAAA;EACA,MAAA;AAkZN;AAjZM;EACC,uBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AAmZP;AAlZO;EACC,cAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAoZR;AAjZG;EACI,aAAA;AAmZP;AAhZI;EACI,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;AAkZR;AAjZQ;EACC,WD7RU;EC8RV,kBAAA;EACA,cAAA;AAmZT;AAjZK;EACI,gBDlSU;ECmSV,kBAAA;EACA,OAAA;EACA,4BAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,4CAAA;AAmZT;AAlZS;EACC,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;AAoZV;AAnZU;EACC,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,wBAAA;AAqZX;AAnZO;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AAqZX;AAlZM;EACI,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAoZV;AAnZU;EACC,iBAAA;EACA,eAAA;EACA,mBAAA;AAqZX;AAnZO;EACI,WAAA;AAqZX;AAhZM;EACC,yBAAA;AAkZP;;AAzYC;EACI,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AA4YL;AA1YC;EACI,UAAA;AA4YL;;AAxYA;EACC,kBAAA;AA2YD;;AAxYA;EACC,WAAA;EACA,YAAA;AA2YD;;AAzYA;EACC,WAAA;AA4YD;;AAzYC;EACC,WAAA;AA4YF;;AAtYA;EACC,UAAA;AAyYD;;AAtYE;EACE,kBAAA;AAyYJ;AAxYI;EACE,sBAAA;AA0YN;AAxYI;EACI,aAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WD3ZW;EC4ZX,2BAAA;EACA,6BAAA;EACA,mCAAA;EACA,2CAAA;AA0YR;AAvYM;EACI,cAAA;AAyYV;;AApYA;EAEK,aAAA;EAEA,iBAAA;AAuYL;AAtYQ;EACF,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AAwYN;AAtYE;EACC,eAAA;EACG,uBAAA;EACA,mBAAA;EACA,gBAAA;AAwYN;AAvYM;EACC,YAAA;AAyYP;AAtYE;EACC,eAAA;EACG,uBAAA;EACA,mBAAA;EACA,gBAAA;AAwYN;AAvYM;EACC,YAAA;AAyYP;;AArYA;EACC,kBAAA;AAwYD;AAtYC;EACC,kBAAA;EACA,SAAA;EACA,QAAA;AAwYF;;AApYA;EACC,WAAA;EACG,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,cAAA;EACA,mBAAA;AAuYJ;;AApYA;qCAAA;AAKA;EA0DI,kBAAA;AA2UJ;AAlYI;;EAEI,qBAAA;GAoYN,eAnYM;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,oFAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAoYR;AAlYI;EACC,sBAAA;EACA,gBAAA;EACA,gBAAA;EACH,gBAAA;AAoYF;AAlYI;EACI,wBAAA;AAoYR;AAlYI;EACI,4BAAA;AAoYR;AAlYI;EACI,4BAAA;AAoYR;AAlYI;EACI,4BAAA;EACA,eAAA;AAoYR;AAlYI;EACI,4BAAA;AAoYR;AAjYI;EACI,6BAAA;AAmYR;AAjYI;EACI,6BAAA;AAmYR;AAjYI;EACI,6BAAA;AAmYR;AAjYI;EACI,6BAAA;EACA,eAAA;AAmYR;AAjYI;EACI,6BAAA;AAmYR;AA/XI;EACI;;IAEI,mFAAA;IAEA,2BAAA;EAiYV;AACF;;AA9XA;EACC;IACC,WAAA;EAiYA;EA/XD;IACI,sBAAA;IACA,WAAA;IACA,gBAAA;IACA,iBAAA;IACA,oBAAA;IACA,qBAAA;EAiYH;AACF;AA/XA;EACC,eAAA;AAiYD;;AA/XA;EACC,2BAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,6CAAA;EACA,0CAAA;EACG,yBAAA;EACA,wBAAA;EACA,iCAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;EACA,aAAA;AAkYJ;;AA/XA;EACC;IACC,eAAA;EAkYA;AACF;AAhYA;EAEM,8CAAA;EACA,sBAAA;AAiYN;;AA/XA;EACC,kBAAA;AAkYD;;AAnVA;EACC,gBAAA;AAsVD;;AAnVA;EACI,mBAAA;AAsVJ;AArVI;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAuVN;AAtVM;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAwVR;AAtVM;EACE,iBAAA;EACA,oBAAA;AAwVR;AArVM;EACE,aAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;AAuVR;AAtVQ;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AAwVV;AAvVY;EACE,eAAA;AAyVd;AAvVY;EACE,gBAAA;AAyVd;AAxVc;EACI,oBAAA;AA0VlB;AAxVc;EACE,eAAA;AA0VhB;AAxVc;EACE,gBAAA;AA0VhB;AArVM;EACE,iBAAA;EACA,oBAAA;AAuVR;;AAjVA;EACI,kBAAA;EACA,+BAAA;AAoVJ;AAlVQ;EACA,kBAAA;EACA,OAAA;EACA,WAAA;EACA,QAAA;AAoVR;;AA/UI;EACE,gBAAA;AAkVN;AAhVM;EACE,6BAAA;AAkVR;;AA5UA;EACE,gCAAA;AA+UF;;AA7UA;EACI,gBAAA;EACA,cAAA;AAgVJ;;AA9UA;EACE,oCAAA;AAiVF;;AA9UA;EACI,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;AAiVJ;;AA/UA;EACI,eAAA;AAkVJ;;AAhVA;EACI,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAmVJ;;AA/UA;EACC,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,iCAAA;EACA,UAAA;AAkVD;AAhVC;EACE,yBAAA;AAkVH;AA/UC;EACE,oCAAA;AAiVH;AA7UG;EACD,mCAAA;AA+UF;AA5UG;EACD,UAAA;AA8UF;AAzUG;EACD,0BAAA;AA2UF;AAvUC;EACE,kBAAA;EACA,gBAAA;AAyUH;AAtUC;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAwUH;AAtUG;EALF;IAMC,YAAA;IACA,iBAAA;EAyUA;AACF;AAvUG;EACD,4BAAA;EACA,yBAAA;EACA,kCAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;AAyUF;AAvUE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;AAyUJ;AAvUI;EACD,aAAA;AAyUH;AArUE;EACE,UAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EAEA,gBAAA;AAuUJ;AAhUI;EACC,mBAAA;AAkUL;AA3TC;EACE,WAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;AA6TH;AA3TG;EACD,qBAAA;EACA,yBAAA;AA6TF;AA1TG;EACD,qBAAA;EACA,yBAAA;AA4TF;AA1TE;EACE,qBAAA;EACA,yBAAA;AA4TJ;AAxTG;EACD,WAAA;EACA,qBAAA;EACA,yBAAA;AA0TF;AAxTE;EACE,qBAAA;EACA,yBAAA;AA0TJ;AAtTG;EACD,WAAA;EACA,qBAAA;EACA,yBAAA;AAwTF;AAtTE;EACE,qBAAA;EACA,yBAAA;AAwTJ;AApTG;EACD,WAAA;EACA,qBAAA;EACA,yBAAA;AAsTF;AApTE;EACE,qBAAA;EACA,yBAAA;AAsTJ;;AAhTE;EACD,gBAAA;AAmTD;;AAhTE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,cAAA;AAmTJ;AAjTI;EACI,aAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AAmTR;AAhTI;EACI,kBAAA;EACA,wCAAA;AAkTR;AAhTQ;EACI,uBAAA;AAkTZ;AA/SQ;EACI,uBAAA;AAiTZ;AA7SI;EACI,kBAAA;EACA,6BAAA;EACA,kBAAA;AA+SR;AA7SQ;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AA+SZ;AA3SI;EACI,0BAAA;AA6SR;AAxSQ;EACI,gBAAA;AA0SZ;AAvSQ;EACI,eAAA;AAySZ;AArSI;EACI,eAAA;EACA,gBAAA;AAuSR;AApSI;EACI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;AAsSR;AApSQ;EACI,gBAAA;AAsSZ;AAlSI;;EAEI,YAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;AAoSR;AAlSQ;;EACI,aAAA;AAqSZ;AAjSI;EACI,iBAAA;EACA,kBAAA;EACA,QAAA;AAmSR;AAhSI;EAEI,sBAAA;EACA,qBAAA;EACA,UAAA;EACA,SAAA;AAiSR;AA7RY;EACI,0BAAA;EACA,oCAAA;EACA,gBAAA;AA+RhB;AA1RI;EACI,aAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,SAAA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AA4RR;AA1RQ;EACI,YAAA;AA4RZ;AAzRQ;EAEI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,+CAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AA0RZ;AAvRQ;EACI,8CAAA;AAyRZ","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../assets/styles/variables';\n\n::ng-deep #holder > li {\n  padding: 5px;\n  margin: 2px;\n  display: inline-block;\n  border-color: #ddd;\n}\n::ng-deep #holder > li[data-page] {\n  border: solid #a0a0a0 1px;\n  border-radius: 5px;\n}\n::ng-deep #holder > li.separator:before {\n  content: '...';\n}\n::ng-deep #holder > li.active {\n  background-color: #f4f4f4;\n  color: inherit;\n}\n::ng-deep #holder > li[data-page]:hover {\n  cursor: pointer;\n}\n::ng-deep .no-profile {\n  background-image: url($assets+\"/images/foursight-profile-types.svg\")!important;\n}\nul.dropdown-menu li a span {\n\tdisplay: block;\n\tfont-size: 65%;\n\ttext-align: center;\n\tmargin: -10px;\n}\n.checkbox input[type=\"checkbox\"]{\n\tmargin-left: 0px;\n}\n.split-groups{\n\tmargin-left: 10px;\n}\n\n.selectDataChild th{\n  min-width: 100px;\n\n}\n\n.selectDataChild th, .selectDataChild td{\n  padding: 5px 10px;\n}\ntable.selectDataChild{\n\twidth: 100%;\n}\ntable.selectDataChild tr:nth-child(odd) {\n    background: $color-neutral-light;\n}\n.top-right-button .btn{\n\tmargin:0 5px;\n}\n::ng-deep.download{\n\twidth: auto;\n\tmargin-left: 20px;\n}\n::ng-deep.download-options{\n\tdisplay: inline-block;\n\n}\n::ng-deep.custom-radio-section {\n\tmargin-top: 10px;\n\t.btn-primary{\n\t\tdisplay: block;\n\t}\n}\n.ibox-content{\n\tborder-top: 0px;\n}\n.group-title-area .dropdown-menu{\n\tposition: absolute;\n\tright: 0;\n\tleft: auto;\n\ttop: 100%;\n\twidth: 110px;\n\tmin-width: inherit\n}\n@media screen and (max-width: 380px){\n\t.group-title-area .btn-group.pull-right {\n        float: none!important;\n\t    margin-left: 10px;\n\t    margin-top: 10px;\n\t    clear: both;\n\t    display: block;\n\t}\n}\n.dropdown-submenu {\n\tposition: relative;\n}\n\n.group-dropdown.dropdown {\n\tposition: relative;\n\tfloat: left;\n\tbutton.btn {\n\t\tfont-size: 13px;\n\t}\n\t.dropdown-menu.inner-toggle {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: auto;\n\t\twidth: 210px;\n\t\tpadding: 10px 10px;\n\t\t.download-options {\n\t\t\tfloat: left;\n\t\t\twidth: 50%;\n\t\t\tselect.form-control {\n\t\t\t\tmargin: 0;\n\t\t\t}\n\t\t}\n\t\t.custom-radio-section {\n\t\t\tfloat: left;\n\t\t\twidth: 50%;\n\t\t\tmargin:0px;\n\t\t\tpadding-left: 20px;\n\t\t}\n\t}\n}\n::ng-deep .dropdown-submenu .dropdown-menu {\n\ttop: 0;\n\tleft: 100%;\n\tmargin-top: -1px;\n}\n::ng-deep.swal2-modal {\n    flex-wrap: wrap;\n    -webkit-flex-wrap: wrap;\n    -moz-flex-wrap: wrap;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -moz-justify-content: center;\n}\n::ng-deep .swal2-show {\n\tbackground-color: white;\n\tfont-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n\twidth: 478px;\n\tpadding: 17px;\n\tborder-radius: 5px;\n\ttext-align: center;\n\tposition: fixed;\n\tleft: 0 !important;\n\ttop: 0 !important;\n\ttransform: translate(0,0) !important;\n\t-webkit-transform: translate(0,0) !important;\n\t-moz-transform: translate(0,0) !important;\n\tmargin-left: -256px;\n\toverflow: hidden;\n\tz-index: 99999;\n\tmargin-top: -168px;\n\t&:focus{\n\t\toutline: none;\n\t}\n\tbutton.swal2-cancel.swal2-styled {\n\t\tbackground-color: #D0D0D0 !important;\n\t\tcolor: white;\n\t\tborder: none;\n\t\tbox-shadow: none;\n\t\tfont-size: 17px;\n\t\tfont-weight: 500;\n\t\t-webkit-border-radius: 4px;\n\t\tborder-radius: 5px;\n\t\tpadding: 10px 32px;\n\t\tmargin: 26px 5px 0 5px;\n\t\tcursor: pointer;\n\t\t&:focus{\n\t\t\toutline: none;\n\t\t}\n\t}\n\tbutton.swal2-confirm.swal2-styled {\n\t\tbackground-color: #AEDEF4;\n\t\tcolor: white;\n\t\tborder: none;\n\t\tbox-shadow: none;\n\t\tfont-size: 17px;\n\t\tfont-weight: 500;\n\t\t-webkit-border-radius: 4px;\n\t\tborder-radius: 5px;\n\t\tpadding: 10px 32px;\n\t\tmargin: 26px 5px 0 5px;\n\t\tcursor: pointer;\n\t\t&:focus{\n\t\t\toutline: none;\n\t\t}\n\t}\n\t.swal2-icon.swal2-warning {\n\t\twidth: 80px;\n\t\theight: 80px;\n\t\tborder: 4px solid gray;\n\t\t-webkit-border-radius: 40px;\n\t\tborder-radius: 40px;\n\t\tborder-radius: 50%;\n\t\tmargin: 20px auto;\n\t\tpadding: 0;\n\t\tposition: relative;\n\t\tbox-sizing: content-box;\n\t\tborder-color: #F8BB86;\n\t\tfont-size: 58px;\n\t\tcolor: #F8BB86;\n\t\t  justify-content: center;\n\t    -webkit-justify-content: center;\n\t    -moz-justify-content: center;\n\t\t&:focus{\n\t\t\toutline: none;\n\t\t}\n\t}\n\th2#swal2-title {\n\t\tcolor: #575757;\n\t\tfont-size: 30px;\n\t\ttext-align: center;\n\t\tfont-weight: 600;\n\t\ttext-transform: none;\n\t\tposition: relative;\n\t\tmargin: 25px 0;\n\t\tpadding: 0;\n\t\tline-height: 40px;\n\t\tdisplay: block;\n\t\t&:focus{\n\t\t\toutline: none;\n\t\t}\n\t}\n\tdiv#swal2-content {\n\t\tcolor: #797979;\n\t\tfont-size: 16px;\n\t\ttext-align: center;\n\t\tfont-weight: 300;\n\t\tposition: relative;\n\t\ttext-align: inherit;\n\t\tfloat: none;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\tline-height: normal;\n\t\t&:focus{\n\t\t\toutline: none;\n\t\t}\n\t}\n}\n::ng-deep .swal2-shown{\n\tbackground-color: black;\n\t-ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";\n\tbackground-color: rgba(0, 0, 0, 0.4);\n\tposition: fixed;\n\tleft: 0;\n\tright: 0;\n\ttop: 0;\n\tbottom: 0;\n\tz-index: 99999;\n}\n.ibox-content.group-list .inner-box.col-lg-3:nth-child(4n+1) {\n\tclear: both;\n}\n.ibox-content.group-list .inner-box.col-lg-2:nth-child(6n+1) {\n\tclear: both;\n}\n.connectPanels{\n\t.profile-image {\n\t    width: 100%;\n\t    max-width: 40px;\n\t}\n\t.cursor-pointer {\n\t    cursor: pointer;\n\t    float: left;\n\t    clear: both;\n\t    margin-top: 10px;\n\t}\n\n}\n\n.hide-wrapper{\n\t.ibox-content h3 {\n\t    // white-space: nowrap;\n\t    // overflow: hidden;\n\t    // text-overflow: ellipsis;\n\t    // width: 117px;\n\t    > span {\n\t\t    white-space: nowrap;\n\t\t    overflow: hidden;\n\t\t    text-overflow: ellipsis;\n\t\t    width: 117px;\n\t\t    display: inline-block;\n\t\t}\n\n\t}\n\t.superCompactView{\n\t\t\th3{\n\t\t\t > span{\n\t\t\t    \twidth: 65px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t.hide-content{\n\t\tdisplay: none;\n\t}\n\t.CompactView{\n\t\th3{\n\t\t > span{\n\t\t    \twidth: 115px;\n\t\t\t}\n\t\t}\n\t}\n\n}\n.global-check{\n\tpadding-top: 10px;\n\tinput[type=\"checkbox\"]{\n\t\twidth: 15px !important;\n\t    vertical-align: middle;\n\t    display: inline-block;\n\t    height: 15px;\n\t    margin-right: 5px;\n\t}\n}\n.compact-box-section{\n\tpadding-top: 20px;\n}\n\n.group-list .row>.col-md-4:nth-child(4n+1) {\n    clear: both;\n}\n\n.hide-wrapper .group-list .row>.col-md-4:nth-child(4n+1) {\n    clear: none;\n}\n\n\n.sortable-list.agile-list{\n\tli.success-element {\n\t    position: relative;\n    \tpadding-top: 18px;\n\t\t.quick-card-editor-buttons{\n\t\t\tposition: absolute;\n\t\t    right: 0;\n\t\t    top: 0;\n\t\t    a.btn.subgroup-edit {\n\t\t\t    background: transparent;\n\t\t\t    border: none;\n\t\t\t    font-size: 0;\n\t\t\t    position: relative;\n\t\t\t    &:before {\n\t\t\t\t    content: \"...\";\n\t\t\t\t    font-size: 25px;\n\t\t\t\t    color: #b7b7b7;\n\t\t\t\t    line-height: 3px;\n\t\t\t\t}\n\t\t\t}\n\t\t\ta.quick-card-editor-buttons-item {\n\t\t\t    display: none;\n\t\t\t}\n\t\t\t&.subgroup-open{\n\t\t\t\ta.quick-card-editor-buttons-item {\n\t\t\t\t    display: block !important;\n\t\t\t\t    position: absolute;\n\t\t\t\t    right: 0;\n\t\t\t\t    background: rgba(0,0,0,0.7);\n\t\t\t\t    border-radius: 5px;\n\t\t\t\t    z-index: 99;\n\t\t\t\t    span.quick-card-editor-buttons-item-text {\n\t\t\t\t\t    color: $color-light-type;\n\t\t\t\t\t    padding: 10px 20px;\n    \t\t\t\t\tdisplay: block;\n\t\t\t\t\t}\n\t\t\t\t\t.subgroup-move {\n\t\t\t\t\t    background: $color-light-type;\n\t\t\t\t\t    position: absolute;\n\t\t\t\t\t    left: 0;\n\t\t\t\t\t    padding: 20px 20px 15px 20px;\n\t\t\t\t\t    border-radius: 4px;\n\t\t\t\t\t    top: 100%;\n\t\t\t\t\t    min-width: 230px;\n\t\t\t\t\t    display: none;\n\t\t\t\t\t    box-shadow: 1px 10px 29px rgba(0,0,0,0.1);\n\t\t\t\t\t    a.close {\n\t\t\t\t\t\t    position: absolute;\n\t\t\t\t\t\t    right: 3px;\n\t\t\t\t\t\t    top: 6px;\n\t\t\t\t\t\t    width: 15px;\n\t\t\t\t\t\t    font-size: 0;\n\t\t\t\t\t\t    opacity: 0.4;\n\t\t\t\t\t\t    z-index: 9999;\n\t\t\t\t\t\t    height: 13px;\n\t\t\t\t\t\t    &:before {\n\t\t\t\t\t\t\t    content: \"\";\n\t\t\t\t\t\t\t    background: #000;\n\t\t\t\t\t\t\t    position: absolute;\n\t\t\t\t\t\t\t    left: 6px;\n\t\t\t\t\t\t\t    top: 0;\n\t\t\t\t\t\t\t    width: 2px;\n\t\t\t\t\t\t\t    height: 13px;\n\t\t\t\t\t\t\t    transform: rotate(45deg);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t    content: \"\";\n\t\t\t\t\t\t\t    background: #000;\n\t\t\t\t\t\t\t    position: absolute;\n\t\t\t\t\t\t\t    left: 6px;\n\t\t\t\t\t\t\t    top: 0;\n\t\t\t\t\t\t\t    width: 2px;\n\t\t\t\t\t\t\t    height: 13px;\n\t\t\t\t\t\t\t    transform: rotate(-45deg);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.list {\n\t\t\t\t\t\t    padding: 10px 10px;\n\t\t\t\t\t\t    background: #e0e0e0;\n\t\t\t\t\t\t    border-radius: 4px;\n\t\t\t\t\t\t    color: #333;\n\t\t\t\t\t\t    h2 {\n\t\t\t\t\t\t\t    font-weight: bold;\n\t\t\t\t\t\t\t    font-size: 17px;\n\t\t\t\t\t\t\t    margin: 0px 0 5px 0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\tselect {\n\t\t\t\t\t\t\t    width: 100%;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&.sub-subgroup-edit{\n\t\t\t\t\t\t.subgroup-move{\n\t\t\t\t\t\t\tdisplay: block !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.col-lg-1 {\n\th3 {\n\t    text-overflow: ellipsis;\n\t    white-space: nowrap;\n\t    width: 64px !important;\n\t    overflow: hidden;\n\t    display: block;\n\t    padding: 2px;\n\t}\n\t.ibox-content.group-content-area {\n\t    padding: 0;\n\t}\n}\n\nh5.team-title {\n\tpadding-left: 10px;\n}\n\n#group-algorithm {\n\twidth: auto;\n\tpadding: 0px;\n}\n.compact-radio {\n\tmargin: 5px;\n}\n.custom-pop-input{\n\tinput[type=\"number\"]{\n\t\twidth: auto;\n\t}\n}\n// .nmbr-groups{\n// \tpadding: 0px;\n// }\n.group-inner-btn{\n\twidth: 37%;\n}\n.reset-input{\n  th{\n    position: relative;\n    input[type=\"search\"]{\n      width: 100% !important;\n    }\n    .reset-close{\n        display: none;\n        position: absolute;\n        top: 0;\n        right: 25px;\n        bottom: 0;\n        margin: auto;\n        border-radius: 50%;\n        background: #ddd;\n        border: none !important;\n        text-align: center;\n        font-size: 14px;\n        padding: 0px !important;\n        height: 16px !important;\n        width: 16px !important;\n        color: $color-light-type;\n        line-height: 1.2 !important;\n        font-family: Arial !important;\n        transform: rotate(45deg) !important;\n        -webkit-transform: rotate(45deg) !important;\n    }\n    &:hover{\n      .reset-close{\n          display: block;\n      }\n    }\n  }\n}\n.ibox-table>.row{\n\t\tdisplay: -ms-flexbox;\n\t    display: flex;\n\t    -ms-flex-wrap: nowrap;\n\t    flex-wrap: nowrap;\n        .inner-box {\n\t\t    display: inline-block;\n\t\t    max-width: 270px;\n\t\t    vertical-align: top;\n\t\t    width: 100%;\n\t\t    padding-left: 15px;\n\t\t    padding-right: 15px;\n\t\t    flex: 0 0 270px;\n\t\t    -webkit-flex: 0 0 270px;\n\t\t    -ms-flex: 0 0 270px;\n\t\t}\n\t\t.inner-box.superCompactView{\n\t\t\tflex: 0 0 100px;\n\t\t    -webkit-flex: 0 0 100px;\n\t\t    -ms-flex: 0 0 100px;\n\t\t    max-width: 115px;\n\t\t    .ibox-content {\n\t\t\t    padding: 5px;\n\t\t\t}\n\t\t}\n\t\t.inner-box.CompactView{\n\t\t\tflex: 0 0 150px;\n\t\t    -webkit-flex: 0 0 150px;\n\t\t    -ms-flex: 0 0 150px;\n\t\t    max-width: 150px;\n\t\t    .ibox-content {\n\t\t\t    padding: 5px;\n\t\t\t}\n\t\t}\n}\n.form-popup{\n\tposition: relative;\n\t// padding-bottom: 35px;\n\tbutton.btn-primary{\n\t\tposition: absolute;\n\t\tbottom:0;\n\t\tright: 0;\n\t}\n}\n\nspan.sortby{\n\twidth: 100%;\n    height: 100%;\n    position: absolute;\n    text-align: right;\n    left: 0px;\n    z-index: 99999;\n    padding-right: 14px;\n}\n\n/* iCheck plugin Square skin, green\n----------------------------------- */\n\n$assets: 'https://assets.foursightonline.com/app';\n\n::ng-deep .compact-box-section{\n\n\n    .icheckbox_square-green,\n    .iradio_square-green {\n        display: inline-block;\n        *display: inline;\n        vertical-align: middle;\n        margin: 0;\n        padding: 0;\n        width: 22px;\n        height: 22px;\n        background: url($assets+'/images/green.png') no-repeat;\n        border: none;\n        cursor: pointer;\n        margin-left: 15px;\n        float: none !important;\n    }\n    label{\n\t   \tvertical-align: middle;\n\t    margin-bottom: 0;\n\t    margin-left: 7px;\n\t\tfont-weight: 700;\n\t    }\n    .icheckbox_square-green {\n        background-position: 0 0;\n    }\n    .icheckbox_square-green.hover {\n        background-position: -24px 0;\n    }\n    .icheckbox_square-green.checked {\n        background-position: -48px 0;\n    }\n    .icheckbox_square-green.disabled {\n        background-position: -72px 0;\n        cursor: default;\n    }\n    .icheckbox_square-green.checked.disabled {\n        background-position: -96px 0;\n    }\n\n    .iradio_square-green {\n        background-position: -120px 0;\n    }\n    .iradio_square-green.hover {\n        background-position: -144px 0;\n    }\n    .iradio_square-green.checked {\n        background-position: -168px 0;\n    }\n    .iradio_square-green.disabled {\n        background-position: -192px 0;\n        cursor: default;\n    }\n    .iradio_square-green.checked.disabled {\n        background-position: -216px 0;\n    }\n\n    /* HiDPI support */\n    @media (-o-min-device-pixel-ratio: 5/4), (-webkit-min-device-pixel-ratio: 1.25), (min-resolution: 120dpi) {\n        .icheckbox_square-green,\n        .iradio_square-green {\n            background-image: url($assets+'/images/green@2x.png');\n            -webkit-background-size: 240px 24px;\n            background-size: 240px 24px;\n        }\n    }\n}\n@media screen and (max-width: 900px){\n\t.page-heading .col-lg-10{\n\t\twidth: auto;\n\t}\t\n\t.ibox-title.top-right-button .right-side-btn {\n\t    float: none !important;\n\t    width: 100%;\n\t    text-align: left;\n\t    padding-top: 15px;\n\t    padding-bottom: 15px;\n\t    display: inline-block;\n\t}\n}\n::ng-deep.swal2-shown{\n\tz-index: 999999;\n}\n::ng-deep.swal2-modal{\n\tmax-width: 500px !important;\n\twidth: 100% !important;\n\tleft: 0 !important;\n\ttop: 0 !important;\n\ttransform: translate(0,0) !important;\n\t-webkit-transform: translate(0,0) !important;\n\t-moz-transform: translate(0,0) !important;\n    margin-left: 0 !important;\n    margin-top: 0 !important;\n    box-sizing: border-box !important;\n    bottom: 0;\n    right: 0;\n    margin: auto !important;\n    height: 390px;\n}\n\n@media screen and (max-width: 380px){\n\t::ng-deep.swal2-modal{\n\t\theight: inherit;\n\t}\n}\n::ng-deep.previous-btn {\n      // margin-right: 10px;\n      background-color: $develop-color !important;\n      color: $color-light-type !important;\n  }\n.top-groups{\n\tmargin-right: 10px;\n}\n// .manage-members-wrapper {\n//     margin-bottom: 20px;\n//     .manage-inner{\n//       float: none;\n//       margin-left: auto;\n//       margin-right: auto;\n//       margin-bottom: 15px;\n//       h3{\n//         padding-top: 10px;\n//         padding-bottom: 10px;\n\n//       }\n//       .inner-block{\n//         display: flex;\n//         display: -ms-flexbox;\n//         flex-wrap:wrap;\n//         -ms-flex-wrap:wrap;\n//         .inner-single-box{  \n//           padding:15px;  \n//           border: 1px solid $border-color;\n//           height: 100%;\n//             i{\n//               font-size: 60px;\n//             }\n//             ul{\n//               margin-top: 10px;\n//               li:first-child{\n//                   padding-bottom: 10px;\n//                 }\n//               li:nth-child(3) {\n//               margin-top: 10px;\n//             }\n//             }\n//           }\n//       } \n//       .bottom-member {\n//         padding-top: 15px;\n//         padding-bottom: 15px;\n//       }\n//     }\n//   }\n\n//   .border-green{\n//   \tborder-color: #86b74b !important;\n// \t}\n.main-top-session{\n\tmargin-top: 15px;\n}\t\n\n.manage-members-wrapper {\n    margin-bottom: 20px;\n    .manage-inner{\n      float: none;\n      margin-left: auto;\n      margin-right: auto;\n      margin-bottom: 15px;\n      h2{\n        font-weight: 600;\n        margin-top: 0;\n        margin-bottom: 30px;\n      }\n      h3{\n        padding-top: 10px;\n        padding-bottom: 10px;\n\n      }\n      .inner-block{\n        display: flex;\n        display: -ms-flexbox;\n        flex-wrap:wrap;\n        -ms-flex-wrap:wrap;\n        .inner-single-box{  \n          padding:15px;  \n          border: 3px solid $border-color;\n          height: 100%;\n          border-radius: 5px;\n            i{\n              font-size: 60px;\n            }\n            ul{\n              margin-top: 40px;\n              li:first-child{\n                  padding-bottom: 10px;\n                }\n              li:nth-child(2) {\n                font-size: 14px;\n              }\n              li:nth-child(3) {\n                margin-top: 10px;\n              }\n            }\n          }\n      } \n      .bottom-member {\n        padding-top: 15px;\n        padding-bottom: 15px;\n      }\n    }\n  }\n  .add-mbr-block{\n\n.inner-single-box {\n    position: relative;\n    padding-bottom: 35px !important;\n    }\n        h5 {\n        position: absolute;\n        left: 0;\n        bottom: 4px;\n        right: 0;\n    }\n  } \n.manage-profile-txt{\n   tr{\n    td{\n      text-align:   left;\n    }\n      td:last-child, th:last-child {\n        text-align: center !important;\n    }\n   } \n  \n}\n\n.border-green{\n  border-color: #86b74b !important;\n}\n::ng-deep.swal2-icon-text {\n    font-size: 1.3em;\n    line-height: 1;\n}\n::ng-deep.grey{\n  background: rgba(236, 236, 236, 0.9);\n}\n\n.inner-box:not(.CompactView, .superCompactView) .group-member-name {\n    white-space: nowrap;\n    width: 110px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.inner-box.CompactView .agile-list li .group-member-name, .inner-box.CompactView .agile-list li span {\n    font-size: 10px;\n}\nspan.no-org {\n    white-space: nowrap;\n    width: 38px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: block;\n    font-size: 10px;\n}\n\n// Modal Design\n::ng-deep .modal {\n\tposition: fixed;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tz-index: 1050;\n\tdisplay: none;\n\toverflow: hidden;\n\t-webkit-overflow-scrolling: touch;\n\toutline: 0;\n  \n\t&.show {\n\t  display: block !important;\n\t}\n  \n\t&.grey {\n\t  background: rgba(236, 236, 236, 0.9);\n\t}\n  \n\t&.fade {\n\t  .modal-dialog {\n\t\ttransition: transform 0.3s ease-out;\n\t  }\n  \n\t  &.in {\n\t\topacity: 1;\n\t  }\n\t}\n  \n\t&.in {\n\t  .modal-dialog {\n\t\ttransform: translate(0, 0);\n\t  }\n\t}\n  \n\t&.modal-open {\n\t  overflow-x: hidden;\n\t  overflow-y: auto;\n\t}\n  \n\t.modal-dialog {\n\t  position: relative;\n\t  width: auto;\n\t  margin: 10px;\n  \n\t  @media (min-width: 768px) {\n\t\twidth: 600px;\n\t\tmargin: 30px auto;\n\t  }\n  \n\t  .modal-content {\n\t\tbackground-clip: padding-box;\n\t\tbackground-color: #FFFFFF;\n\t\tborder: 1px solid rgba(0, 0, 0, 0);\n\t\tborder-radius: 4px;\n\t\tbox-shadow: 0 1px 3px rgb(0 0 0 / 30%);\n\t\toutline: 0 none;\n\t\tposition: relative;\n  \n\t\t.close {\n\t\t  float: right;\n\t\t  font-size: 21px;\n\t\t  font-weight: bold;\n\t\t  line-height: 1;\n\t\t  color: #000;\n\t\t  text-shadow: 0 1px 0 #fff;\n\t\t  filter: alpha(opacity=20);\n\t\t  opacity: 0.2;\n  \n\t\t  &:focus-visible {\n\t\t\toutline: none;\n\t\t  }\n\t\t}\n  \n\t\tbutton.close {\n\t\t  padding: 0;\n\t\t  cursor: pointer;\n\t\t  background: transparent;\n\t\t  border: 0;\n\t\t  -webkit-appearance: none;\n\t\t  appearance: none;\n\t\t}\n\n\t\t.modal-body {\n\n\t\t\tform {\n\n\t\t\t\t.form-group {\n\t\t\t\t\tmargin-bottom: 15px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t  }\n\t}\n  \n\t.f-btn {\n\t  color: #fff;\n\t  font-size: 14px;\n\t  border-color: #73BF38;\n\t  background-color: #73BF38;\n  \n\t  &:hover {\n\t\tborder-color: #4cae4c;\n\t\tbackground-color: #4cae4c;\n\t  }\n\n\t  &--seagrn {\n\t\tborder-color: #1dc5a3;\n\t\tbackground-color: #1dc5a3;\n\t\n\t\t&:hover {\n\t\t  border-color: #1dc5a3;\n\t\t  background-color: #1dc5a3;\n\t\t}\n\t  }\n  \n\t  &--dngr {\n\t\tcolor: #fff;\n\t\tborder-color: #ED5565;\n\t\tbackground-color: #ED5565;\n  \n\t\t&:hover {\n\t\t  border-color: #ec4758;\n\t\t  background-color: #ec4758;\n\t\t}\n\t  }\n  \n\t  &--info {\n\t\tcolor: #fff;\n\t\tborder-color: #23c6c8;\n\t\tbackground-color: #23c6c8;\n  \n\t\t&:hover {\n\t\t  border-color: #21b9bb;\n\t\t  background-color: #21b9bb;\n\t\t}\n\t  }\n  \n\t  &--wrng {\n\t\tcolor: #fff;\n\t\tborder-color: #f8ac59;\n\t\tbackground-color: #f8ac59;\n  \n\t\t&:hover {\n\t\t  border-color: #f7a54a;\n\t\t  background-color: #f7a54a;\n\t\t}\n\t  }\n\t}\n  }\n  \n  ::ng-deep.modal-open {\n\toverflow: hidden;\n  }\n\n  .dialogbox {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgb(236 236 236 / 90%);\n    z-index: 99999;\n\n    &__wrapper {\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: center;\n        width: 100%;\n        height: 100%;\n        overflow-y: auto;\n        padding: 30px;\n    }\n\n    &__inner {\n        border-radius: 4px;\n        box-shadow: 0 1px 3px rgb(0 0 0 / 30%);\n\n        &[data-width=\"small\"] {\n            width: min(390px, 100%);\n        }\n\n        &[data-width=\"medium\"] {\n            width: min(500px, 100%);\n        }\n    }\n\n    &__hdr {\n        padding: 15px 30px;\n        border-bottom: 1px solid $clrDarkGray1;\n        position: relative;\n\n        h2 {\n            font-size: 17px;\n            line-height: 1.3;\n            font-weight: 400;\n        }\n    }\n\n    &__ftr {\n        border-top: 1px solid $clrDarkGray1;\n    }\n\n    .dialogbox__steps {\n\n        :is(ul, ol):last-child {\n            margin-bottom: 0;\n        }\n\n        li {\n            font-size: 12px;\n        }\n    }\n\n    &__smalllabel {\n        font-size: 12px;\n        font-weight: 400;\n    }\n\n    label {\n        display: inline-block;\n        max-width: 100%;\n        margin-bottom: 0;\n        font-weight: 700;\n        margin-top: 0;\n\n        &:last-child {\n            margin-bottom: 0;\n        }\n    }\n\n    select,\n    input[type=\"text\"] {\n        height: 35px;\n        padding: 3px 10px;\n        width: 100%;\n        background-color: #fff;\n        border: 1px solid $clrDarkGray1;\n\n        &:focus {\n            outline: none;\n        }\n    }\n\n    input[type=\"radio\"] {\n        margin: 0 5px 0 0;\n        position: relative;\n        top: 2px;\n    }\n\n    &__dpsteps {\n\n        counter-reset: section;\n        list-style-type: none;\n        padding: 0;\n        margin: 0;\n\n        &-hdr {\n\n            &::before {\n                counter-increment: section;\n                content: counters(section, \".\") \". \";\n                font-weight: 700;\n            }\n        }\n    }\n\n    &__close {\n        --cSize: 16px;\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        right: 15px;\n        width: var(--cSize);\n        height: var(--cSize);\n        padding: 0;\n        border: 0;\n        background-color: transparent;\n        opacity: 0.2;\n        transition: 0.3s;\n        cursor: pointer;\n\n        &:hover {\n            opacity: 0.4;\n        }\n\n        &::before,\n        &::after {\n            content: \"\";\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%) rotate(-45deg);\n            width: 2px;\n            height: 100%;\n            background-color: #000;\n            border-radius: 2px;\n        }\n\n        &::after {\n            transform: translate(-50%, -50%) rotate(45deg);\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
